export function StringSelect (what) {
  return function (conditions, otherwise) {
    for (const key in conditions) {
      if (key === what) {
        return conditions[key]
      }
    }
    return otherwise
  }
}